import { render } from "./system_communications.html?vue&type=template&id=4d1dc6a0&scoped=true&external"
import script from "./system_communications.js?vue&type=script&lang=js&external"
export * from "./system_communications.js?vue&type=script&lang=js&external"

import "./SystemCommunications.vue?vue&type=style&index=0&id=4d1dc6a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1dc6a0"]])

export default __exports__